import { Component, OnInit } from '@angular/core';
import { OrderDeleteModal } from '../orderdelete/orderdelete.component';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../../../services/data/data.service';
import { WorkspaceServiceService } from '../../../services/workspace-service.service';
import {MobileTradeDeskOrdersTabComponent} from '../../mobile-trade-desk-orders-tab/mobile-trade-desk-orders-tab.component';

@Component({
  selector: 'app-mobile-order-delete',
  template: require('./mobile-order-delete.component.html'),
  styles: [require('./mobile-order-delete.component.scss')]
})
export class MobileOrderDeleteComponent extends OrderDeleteModal {

  constructor( private _router: Router,
    private _fb: FormBuilder,
    public _activeModal: NgbActiveModal,
    private _dataService: DataService, protected workspaceServiceService: WorkspaceServiceService,
   
    ) {
      
    super(_router, _fb, _activeModal, _dataService);

    


   }

  ngOnInit() {
  }

  get horizontal()
  {
    return this.workspaceServiceService.data.horizontalMode;
  }
  
  
  public hideButtons()
  {
    this.workspaceServiceService.data.globaGridMode.mobileOrderButtonState.next(true);
  }

}

export function ShowOrderDeleteMobileModal(modalService: NgbModal, orderData:any, oldestOrder:string){
  let m:NgbModalRef= modalService.open(MobileOrderDeleteComponent,{
      backdrop: "static",
      size: "sm",
      centered: true, 
      windowClass: "dark-modal mobile"
  });
  let modal = (<MobileOrderDeleteComponent>m.componentInstance);
  modal.orderRowData = orderData;
  modal.oldestOrder = oldestOrder;
  return m.result;
}